document.addEventListener("readystatechange", function (e) {
  switch (e.target.readyState) {
    case "complete":
      if ($(".custom-slider").length != 0) {
        $(".custom-slider").owlCarousel({
          loop: true,
          margin: 10,
          items: 1,
          lazyLoad: true,
          nav: true,
          navText: [
            "<i class='bx bx-left-arrow-alt'></i>",
            "<i class='bx bx-right-arrow-alt'></i>",
          ],
          dots: true,
          mouseDrag: false,
          animateOut: "fadeOut",
          animateIn: "fadeIn",
        });
      }
      if ($(".product-slider").length !== 0) {
        $(".product-slider").owlCarousel({
          loop: true,
          margin: 15,
          items: 4.3,
          nav: true,
          navText: [
            "<i class='bxr bx-chevrons-left'></i>",
            "<i class='bxr bx-chevrons-right'></i>",
          ],
          dots: false,
          mouseDrag: false,
          animateOut: "fadeOut",
          animateIn: "fadeIn",
          responsive: {
            0: {
              items: 1.2, // For small screens
            },
            576: {
              items: 2, // Small devices like tablets
            },
            768: {
              items: 3, // Medium devices
            },
            992: {
              items: 4, // Large devices
            },
            1200: {
              items: 4.3, // Extra large screens
            },
          },
        });
      }
      if ($(".video-slider").length !== 0) {
        let videoSlider = $(".video-slider");
        videoSlider.owlCarousel({
          loop: false,
          margin: 10,
          stagePadding: 90,
          items: 3,
          nav: true,
          navText: [
            "<i class='bxr bx-arrow-left-stroke'></i>",
            "<i class='bxr bx-arrow-right-stroke'></i>",
          ],
          dots: false,
          mouseDrag: false,
          animateOut: "fadeOut",
          animateIn: "fadeIn",
          responsive: {
            0: {
              items: 1.2, // For small screens
            },
            576: {
              items: 1.9, // Small devices like tablets
            },
            768: {
              items: 2.4, // Medium devices
            },
            992: {
              items: 2.8, // Large devices
            },
            1200: {
              items: 3, // Extra large screens
            },
          },
        });
      }
      break;
  }
});
$(document).on("change", "#product-type", function () {
  let self = $(this);
  let concern = self.find("option:selected").attr("data-concern").split(",");
  var sOpt = "<option disabled selected>concern</option>";
  $.each(concern, function (k, v) {
    let val = v.split("|");
    sOpt +=
      '<option data-url="' +
      val[1] +
      '" value="' +
      val[0] +
      '">' +
      val[0] +
      "</option>";
  });
  $("#concern").html(sOpt).removeAttr("disabled");
  $(".button-formula button").prop("disabled", false);
});
$(document).on("click", ".button-formula button", function () {
  window.location.href = $("#concern").find("option:selected").attr("data-url");
});
$(document).on("click", ".up-button", function () {
  $(this).parent().toggleClass("open");
  $(this).parents().eq(1).height($(this).parents().eq(4).height() + 'px')
});
function playMiddleVideo() {
  let self = $(".video-slider");
  self.find(".owl-item video").each(function () {
    this.pause();
    this.currentTime = 0;
  });
  var activeItems = self.find(".owl-item.active");
  var middleIndex = Math.floor(activeItems.length / 2);
  var middleItem = activeItems.eq(middleIndex);
  var video = middleItem.find("video");
  if (video.length) {
    video.attr("loop", true);
    video.get(0).play();
  }
}
$(document).on('click', '.product-card-wrapper .card__media, .image-with-text__media, .multicolumn-card__image-wrapper, .clickable-link', function (e) {
  let self = $(this);
  let href = self.data('href');
  if (href) {
    window.location.href = href;
  }
});

// before and after slider
const container = document.querySelector('.before-after-container');
document.querySelector('.before-after-container .slider').addEventListener('input', (e) => {
  container.style.setProperty('--position', `${e.target.value}%`);
})
$(document).on('click','.play-video',function(){
    let self = $(this);
    self.parent().find('video')[0].play();
    self.addClass('d-none');
});